/*
 *   File : create-mandate.js
 *   Author : https://evoqins.com
 *   Description : Mandate create and update modal
 *   Integrations : 
 *   Version : 1.0.0
*/

import React, { memo, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

//custom component
import { PrimaryButton } from '../Buttons';
import { CustomAmountInput } from "../Form-Elements";
import { _createMandate } from "../../Helper/api";
import { Icon } from "../Icon";


// Styles
import Colors from "../../Style/color.scss";

// Assets
import CloseBtn from "../../Assets/Images/close-btn-white.svg";
import MandateSuccess from "../../Assets/Images/success.webp";
import { MandateOptions } from "../Other";

const CreateMandateModal = (props) => {

    const otpInputRef = useRef(null);
    const userData = useSelector((store) => store.Reducer.USER_DATA);

    const [selectedMandateType, setSelectedMandateType] = useState("UPI"); // default to UPI
    const [currentStep, setCurrentStep] = useState(1);
    const [amount, setAmount] = useState(100000);
    const [amountError, setAmountError] = useState("");

    const [otpValue, setOtpValue] = useState("");
    const [otpError, setOtpError] = useState("");
    const [timer, setTimer] = useState(30);
    const [focusedInput, setFocusedInput] = useState(0);
    const [disableResendOTP, setDisableResendOTP] = useState(false); // for Resend OTP
    const [loading, setLoading] = useState(false);


    //for timer
    useEffect(() => {
        if (currentStep === 2 && timer > 0) {
            // Start the timer when requestOtpSuccess becomes true
            const countdown = setInterval(() => {
                setTimer((prevTimer) => prevTimer - 1);
            }, 1000);
            // Clear the timer when the component unmounts or when the timer reaches 0
            return () => {
                clearInterval(countdown);
            };
        }
    }, [currentStep, timer]);

    //handle amount
    const _handleMandateAmountChange = (value) => {
        setAmount(value);
        setAmountError("");
    };


    const _handleContinue = () => {
        if (amount === 0) {
            setAmountError("Mandate amount is required");
        } else {
            // setCurrentStep(2);
            // API call
            setLoading(true);
            _createMandate(amount, selectedMandateType).then(status => {
                if (status.status_code === 200) {

                    const mandate_window = window.open(status.data.mandate_url, "", "width=500,height=500,left=400,top=100");

                    if (mandate_window === null || typeof mandate_window === 'undefined') {
                        toast.dismiss();
                        toast.error("please enable Pop-up to open mandate window", { className: "e-toast", });
                        setLoading(false);
                        return;
                    };



                    let timer = setInterval(function () {
                        if (mandate_window.closed) {
                            clearInterval(timer);
                            // toast.dismiss();
                            // toast.success("Mandate created successfully", { className: "e-toast", });
                            // let close_btn = document.querySelector("#mandate-modal-close-btn");
                            // close_btn.click();
                            // props.handleSuccess();
                            setCurrentStep(2);
                            setLoading(false);
                        };
                    }, 1000);

                } else {
                    toast.dismiss();
                    toast.error(status.message, { className: "e-toast", });
                    setLoading(false);
                };
            });
        }
    };

    return (
        <div className="modal fade"
            id="create-mandate-modal"
            tabIndex="-1"
            data-bs-backdrop="static"
            aria-labelledby="Create Mandate Modal Label"
            aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content  e-bg-lotion e-border-radius-24 e-addbank-box-shadow mx-lg-4">
                    {
                        currentStep === 1 ?
                            <>

                                <div className="modal-header justify-content-between pt-4  px-4 pb-0 border-0">
                                    <h6 className='e-font-16-res mb-2 e-text-charleston-green e-font-18 e-alt-font-poppins e-font-weight-600 line-height-24px'>
                                        Create Mandate
                                    </h6>
                                    <img src={CloseBtn}
                                        id="mandate-modal-close-btn"
                                        draggable={false}
                                        className='cursor-pointer width-24px-res'
                                        data-bs-dismiss="modal"
                                        aria-label="close"
                                        alt='close btn'
                                        onClick={props.onCloseModal} />
                                </div>
                                <div className="modal-body px-4 pb-4 pt-4">
                                    {/* Annual amount */}
                                    <div id='amount'>
                                        <div id='amount'>
                                            <CustomAmountInput label='Mandate amount upto*'
                                                placeholder={"50,000"}
                                                value={amount}
                                                floatingLabel
                                                errorMsg={amountError}
                                                maxLength={8}
                                                handleChange={_handleMandateAmountChange} />
                                        </div>
                                    </div>
                                    <h6 className='my-3 e-text-charleston-green e-alt-font-poppins e-font-14 e-font-weight-600 line-height-24px'>
                                        Manage Mandate
                                    </h6>
                                    <MandateOptions
                                        type={2}
                                        selectedType={selectedMandateType}
                                        handleTypeSelect={(type) => setSelectedMandateType(type)} />
                                    <div className='d-flex align-items-start gap-1 e-bg-cornsilk e-border-radius-16 p-2 mt-3'>
                                        <Icon icon="info"
                                            size={"0.75rem"}
                                            className="mt-1"
                                            color={Colors.ochre} />
                                        <span className='e-text-ochre e-alt-font-poppins e-font-14 e-font-weight-400 line-height-24px'>
                                            We’ll debit ₹1 from your account to verify the details. We’ll refund this once the verification is complete .
                                        </span>
                                    </div>
                                    <div className="mt-5 text-center">
                                        <PrimaryButton name="Continue"
                                            loading={loading}
                                            disabled={loading}
                                            className="padding-14px-tb col-12 col-sm-10 padding-8px-all-res"
                                            onPress={_handleContinue} />
                                    </div>
                                </div>
                            </>
                            :
                            currentStep === 2 ?
                                <div className="modal-gradient-bg e-border-radius-24">
                                    <div className="modal-header justify-content-end pt-4  px-4 pb-0 border-0">
                                        <img src={CloseBtn}
                                            draggable={false}
                                            data-bs-dismiss="modal"
                                            width={32}
                                            height={32}
                                            className='cursor-pointer float-end align-self-end width-24px-res'
                                            alt='close btn'
                                            onClick={props.handleSuccess} />
                                    </div>
                                    <div className="modal-body p-4 pt-0">
                                        <div className="d-flex flex-column align-items-center">

                                            <img className="img-fluid col-5"
                                                draggable={false}
                                                width={200}
                                                height={200}
                                                src={MandateSuccess}
                                                alt="payment status image" />
                                            <p className="e-font-14-res text-center e-text-ufo-green e-alt-font-poppins e-font-18 e-font-weight-600 mt-4 mb-2">
                                                Mandate Created Successfully
                                            </p>
                                            <p className="px-lg-4 e-font-12-res line-height-20px-res col-sm-10 mx-auto text-center e-text-dark-liver e-alt-font-poppins e-font-14 e-font-weight-400 line-height-26px text-center mx-auto mb-0 mb-5 ">
                                                You can now enable auto-debit for your transactions seamlessly.
                                            </p>
                                            <PrimaryButton name={"Back"}
                                                dismiss={"modal"}
                                                className="padding-12px-tb padding-8px-all-res col-11 col-sm-8 mx-auto e-font-14"
                                                onPress={props.handleSuccess} />
                                        </div>
                                    </div>
                                </div> : null
                    }
                </div>
            </div>
        </div>
    )
}

export default memo(CreateMandateModal);

